var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAIconImportant30 = function SvgAIconImportant30(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 20.2C14.7604 20.2 14.5664 20.394 14.5664 20.6333C14.5664 20.8727 14.7604 21.0667 14.9997 21.0667C15.2391 21.0667 15.4331 20.8727 15.4331 20.6333C15.4331 20.394 15.2391 20.2 14.9997 20.2V20.2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.7333V7.2",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 28C22.1797 28 28 22.1797 28 15C28 7.8203 22.1797 2 15 2C7.8203 2 2 7.8203 2 15C2 22.1797 7.8203 28 15 28Z",
    strokeWidth: 1.5
  })));
};
export { SvgAIconImportant30 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMCIgaGVpZ2h0PSIzMCIgdmlld0JveD0iMCAwIDMwIDMwIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciI+CjxwYXRoIGQ9Ik0xNC45OTk3IDIwLjJDMTQuNzYwNCAyMC4yIDE0LjU2NjQgMjAuMzk0IDE0LjU2NjQgMjAuNjMzM0MxNC41NjY0IDIwLjg3MjcgMTQuNzYwNCAyMS4wNjY3IDE0Ljk5OTcgMjEuMDY2N0MxNS4yMzkxIDIxLjA2NjcgMTUuNDMzMSAyMC44NzI3IDE1LjQzMzEgMjAuNjMzM0MxNS40MzMxIDIwLjM5NCAxNS4yMzkxIDIwLjIgMTQuOTk5NyAyMC4yVjIwLjIiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CjxwYXRoIGQ9Ik0xNSAxNi43MzMzVjcuMiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSAyOEMyMi4xNzk3IDI4IDI4IDIyLjE3OTcgMjggMTVDMjggNy44MjAzIDIyLjE3OTcgMiAxNSAyQzcuODIwMyAyIDIgNy44MjAzIDIgMTVDMiAyMi4xNzk3IDcuODIwMyAyOCAxNSAyOFoiIHN0cm9rZS13aWR0aD0iMS41IiAvPgo8L3N2Zz4=";